import { authenticatedRequest, AuthRequestInit } from './auth';

const request = authenticatedRequest;

// Make sure we don't unnecessarily slow down our test runs
const DEFAULT_BASE_RETRY_TIMEOUT = process.env.NODE_ENV === 'test' ? 0 : 400;

export class NotFoundError extends Error {
  constructor(msg?: string) {
    super(msg);
    this.name = 'NotFoundError';
  }
}

export class ForbiddenError extends Error {
  constructor(msg?: string) {
    super(msg);
    this.name = 'ForbiddenError';
  }
}

export function assertSuccess(response: Response) {
  if (response.status === 403) throw new ForbiddenError();
  if (response.status === 404) throw new NotFoundError();
  if (!(response.status >= 200 && response.status <= 299)) throw new Error();
}

const delay = (timeout: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
};

export const retryWithExponentialBackoff = async (
  sendRequest: () => Promise<Response>,
  maxTries: number,
  baseTimeout: number = DEFAULT_BASE_RETRY_TIMEOUT,
) => {
  let attempts = 1;
  let lastResponse = await sendRequest();

  while (lastResponse.status >= 500 && attempts < maxTries) {
    await delay(2 ** attempts * baseTimeout);
    attempts++;
    lastResponse = await sendRequest();
  }

  return lastResponse;
};

export const get = (url: string, options: AuthRequestInit = {}) =>
  retryWithExponentialBackoff(
    () =>
      request(url, {
        ...options,
      }),
    3,
  );
export const post = (url: string, options: AuthRequestInit = {}) =>
  request(url, {
    method: 'POST',
    ...options,
  });
export const put = (url: string, options: AuthRequestInit = {}) =>
  request(url, {
    method: 'PUT',
    ...options,
  });

export const del = (url: string, options: AuthRequestInit = {}) =>
  request(url, {
    method: 'DELETE',
    ...options,
  });
